import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { renameSleeveFolder } from '../../../../../services/CommonService';
import { toast } from 'react-toastify';

const RenameFolderModal = ({ show, onHide, folderData, onSuccess, onRefresh, onRefreshDocuments }) => {
  const [newFolderName, setNewFolderName] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ name: '' });

  useEffect(() => {
    if (folderData) {
      setNewFolderName(folderData.name || '');
    }
  }, [folderData]);

  const validateForm = () => {
    const newErrors = { name: '' };
    let isValid = true;

    if (!newFolderName.trim()) {
      newErrors.name = 'Folder name is required';
      isValid = false;
    }

    if (!folderData?.envelope_id) {
      newErrors.name = 'Envelope ID is missing';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = {
        envelope_id: Number(folderData.envelope_id),
        old_folder_name: folderData.name,
        new_folder_name: newFolderName.trim(),
      };

      console.log('Rename folder payload:', payload);

      await renameSleeveFolder(payload);

      toast.success(`Folder renamed successfully to "${newFolderName.trim()}"`);

      // Trigger parent component to refetch data and update UI
      onSuccess(newFolderName.trim());

      // Automatically close modal
      handleClose();

      if (typeof onRefresh === 'function') {
        onRefresh();
      }

      // Call onRefreshDocuments to refresh the document list
      if (onRefreshDocuments) {
        onRefreshDocuments();
      }
    } catch (error) {
      console.error('Rename folder error:', error);
      toast.error('Failed to rename folder');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setNewFolderName('');
    setErrors({ name: '' });
    onHide();
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Rename Folder</Modal.Title>
          <button
                type="button"
                className="bg-transparent fw-bold"
                onClick={()=> handleClose(false)}
                disabled={loading}
                aria-label="Close"
              >
                <i className="bi bi-x-lg me-2"></i>
              </button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Folder Name</Form.Label>
              <Form.Control
                type="text"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                placeholder="Enter new folder name"
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Renaming...' : 'Rename'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RenameFolderModal;